var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    cx: 64.75,
    cy: 64.75,
    r: 64.75
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.877 31.764)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.955 65.04H4.233A4.233 4.233 0 0 1 0 60.807V4.372A4.233 4.233 0 0 1 4.233.139h67.722a4.233 4.233 0 0 1 4.233 4.233v56.435a4.233 4.233 0 0 1-4.233 4.233z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.822 60.807V.38A4.244 4.244 0 0 0 0 4.372v56.435a4.233 4.233 0 0 0 4.233 4.233h67.722c1.84 0 3.39-1.182 3.974-2.822H4.233a1.41 1.41 0 0 1-1.411-1.41z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.955 62.218H4.233a1.41 1.41 0 0 1-1.411-1.41v-45.15c0-.778.631-1.41 1.41-1.41h67.723c.78 0 1.411.632 1.411 1.41v45.15c0 .778-.631 1.41-1.41 1.41zM70.544 8.604H19.752a1.41 1.41 0 1 1 0-2.821h50.792a1.41 1.41 0 1 1 0 2.821z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.668 36.822h-16.93a1.41 1.41 0 1 1 0-2.822h16.93a1.41 1.41 0 1 1 0 2.822zM66.15 30.714H44.16c-1.014 0-1.833-.262-1.833-1.411 0-1.15.82-1.411 1.832-1.411h21.99c1.014 0 1.833.427 1.833 1.41 0 .985-.82 1.412-1.832 1.412zM53.614 42.466h-9.876a1.41 1.41 0 1 1 0-2.822h9.876a1.41 1.41 0 1 1 0 2.822z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CCC",
    cx: 5.644,
    cy: 7.194,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CCC",
    cx: 9.876,
    cy: 7.194,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CCC",
    cx: 14.109,
    cy: 7.194,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.722 51.257-6.946-2.894a2.822 2.822 0 0 1-1.736-2.605v-4.703H19.752v4.703c0 1.139-.685 2.167-1.736 2.605l-6.946 2.894a4.233 4.233 0 0 0-2.605 3.907v7.054h33.862v-7.054a4.233 4.233 0 0 0-2.605-3.907z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.752 41.055v4.703c0 .26-.035.516-.103.76a11.164 11.164 0 0 0 11.494 0 2.826 2.826 0 0 1-.103-.76v-4.703H19.752z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.396 24.124c-4.675 0-8.465 3.159-8.465 7.055v5.643a8.465 8.465 0 0 0 16.93 0V31.18c0-3.896-3.79-7.055-8.465-7.055z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.163 36.822v-7.054c0-2.288 1.313-4.315 3.337-5.603-4.254.373-7.57 3.37-7.57 7.014v5.643a8.465 8.465 0 0 0 8.466 8.465c.732 0 1.448-.093 2.126-.268-3.65-.94-6.359-4.254-6.359-8.197z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.327 59.397H16.93a5.644 5.644 0 0 1-5.644-5.644v-2.587l-.216.09a4.233 4.233 0 0 0-2.606 3.908v7.054h33.862v-2.821z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.667 41.377-17.104 5.95a1.412 1.412 0 0 0-.94 1.47c.402 4.277 2.898 19.874 18.19 29.854a1.445 1.445 0 0 0 1.561 0c15.292-9.98 17.789-25.577 18.19-29.854a1.412 1.412 0 0 0-.94-1.47l-17.103-5.95a2.821 2.821 0 0 0-1.854 0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.144 65.343a1.41 1.41 0 0 1-.997-.413l-5.797-5.797a1.41 1.41 0 1 1 1.995-1.996l4.8 4.8 8.112-8.112a1.41 1.41 0 1 1 1.995 1.995l-9.11 9.11a1.411 1.411 0 0 1-.998.413z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.938 45.805-4.374 1.521a1.412 1.412 0 0 0-.941 1.47c.402 4.278 2.898 19.875 18.19 29.855a1.445 1.445 0 0 0 1.561 0 41.75 41.75 0 0 0 2.617-1.854c-12.53-9.916-16.073-24.165-17.053-30.992z",
    fill: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPlaceholder);
export default __webpack_public_path__ + "static/media/member-placeholder.2b065cbcc063f6beb3fa2f01bc072e3b.svg";
export { ForwardRef as ReactComponent };